export default class LangType {
  constructor (app) {
    this.app = app
  }
  get () {
    if (this.app === 'excm') {
      return {
        roles: {
          roleServiceman: 'Serwisant',
          roleExternalServiceman: 'Serwisant zewnętrzny',
          roleDispatcher: 'Dyspozytor',
          roleSalesRepresentative: 'Przedstawiciel handlowy'
        },
        buttons: {
          backToFirm: 'Wróć do firmy'
        },
        views: {
          firm: {
            list: {
              noFirm: 'firm'
            },
            create: {
              title: 'firmę',
              type: 'firmy'
            }
          }
        },
        menu: {
          serviceman: {
            index: `Serwisanci`,
            create: `serwisanta`
          },
          firm: {
            index: 'Firmy',
            create: 'Utwórz firmę'
          },
          service: {
            index: 'Serwis'
          },
          cases: {
            show: 'Zgłoszenie',
            index: 'Zgłoszenia',
            list: 'Zgłoszenia',
            create: 'zgłoszenie'
          },
          casetypes: {
            list: 'zgłoszeń',
            create: 'zgłoszenia'
          }
        },
        routes: {
          ServicemanList: 'serwisantów',
          ServicemanShow: 'serwisanta',
          FirmList: 'Firmy',
          FirmCreate: 'Dodawanie firmy',
          FirmUpdate: 'Edycja firmy',
          FirmShow: 'Firma',
          DashboardClient: 'Pulpit Klienta'
        },
        modals: {
          firm: {
            createFirmHeader: 'Dodawanie firmy dla'
          }
        }
      }
    }
    if (this.app === 'drogbruk') {
      return {
        roles: {
          roleServiceman: 'Wykonawca',
          roleExternalServicemanServiceman: 'Wykonawca zewnętrzny',
          roleDispatcher: 'Koordynator',
          roleSalesRepresentative: 'Przedstawiciel handlowy'
        },
        buttons: {
          backToFirm: 'Wróć do firmy'
        },
        views: {
          firm: {
            list: {
              noFirm: 'kontrahentów'
            },
            create: {
              title: 'kontrahenta',
              type: 'kontrahenta'
            }
          }
        },
        menu: {
          serviceman: {
            index: `Wykonawcy`,
            create: `wykonawcę`
          },
          firm: {
            index: 'Kontrahenci',
            create: 'Utwórz Kontrahenta'
          },
          service: {
            index: 'Zlecenia'
          },
          cases: {
            index: 'Zlecenia',
            show: 'Zlecenie',
            list: 'zlecenia',
            create: 'zlecenie'
          },
          casetypes: {
            list: 'zleceń',
            create: 'zlecenia'
          }
        },
        routes: {
          ServicemanList: 'wykonawców',
          ServicemanShow: 'wykonawcy',
          FirmList: 'Kontrahenci',
          FirmCreate: 'Dodawanie kontrahenta',
          FirmUpdate: 'Edycja kontrahenta',
          FirmShow: 'Kontrahent',
          DashboardClient: 'Pulpit klienta'
        },
        modals: {
          firm: {
            createFirmHeader: 'Dodawanie kontrahenta dla'
          }
        }
      }
    }
  }
}
